const MIME_BY_EXTENSION: Readonly<Record<string, string>> = {
  pdf: 'application/pdf',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
};

const GENERIC_MIME_TYPES = new Set(['', 'application/octet-stream']);

const normalizedMime = (value?: unknown): string =>
  typeof value === 'string' ? value.split(';', 1)[0].trim().toLowerCase() : '';

export function resolveDocumentPreviewMime({
  filename,
  declaredMimeType,
  blobMimeType,
  responseContentType
}: {
  filename: string;
  declaredMimeType?: string | null;
  blobMimeType?: string | null;
  responseContentType?: unknown;
}): string {
  const extension = filename.split('.').pop()?.toLowerCase() ?? '';
  const extensionMime = MIME_BY_EXTENSION[extension];
  if (extensionMime) return extensionMime;

  for (const candidate of [
    responseContentType,
    blobMimeType,
    declaredMimeType
  ]) {
    const mimeType = normalizedMime(candidate);
    if (!GENERIC_MIME_TYPES.has(mimeType)) return mimeType;
  }
  return 'application/octet-stream';
}

export function withDocumentPreviewMime(blob: Blob, mimeType: string): Blob {
  return normalizedMime(blob.type) === mimeType
    ? blob
    : blob.slice(0, blob.size, mimeType);
}
